module.exports = __webpack_public_path__ + "static/media/weighing.21547252.gif";